<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-model="form.name"
			:error="inputErrors.name"
			label="name"
		/>
		<smart-input
			v-model="form.email"
			:error="inputErrors.email"
			label="email"
		/>
		<smart-input
			v-model="form.email_verified_at"
			:error="inputErrors.email_verified_at"
			label="email_verified_at"
		/>
		<smart-input
			v-model="form.password"
			:error="inputErrors.password"
			label="password"
		/>
		<smart-input
			v-model="form.two_factor_secret"
			:error="inputErrors.two_factor_secret"
			label="two_factor_secret"
		/>
		<smart-input
			v-model="form.two_factor_recovery_codes"
			:error="inputErrors.two_factor_recovery_codes"
			label="two_factor_recovery_codes"
		/>
		<smart-input
			v-model="form.provider"
			:error="inputErrors.provider"
			label="provider"
		/>
		<smart-input
			v-model="form.provider_id"
			:error="inputErrors.provider_id"
			label="provider_id"
		/>
		<smart-input
			v-model="form.current_team_id"
			:error="inputErrors.current_team_id"
			label="current_team_id"
		/>
		<smart-input
			v-model="form.profile_photo_path"
			:error="inputErrors.profile_photo_path"
			label="profile_photo_path"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				:loading="inProgress"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import UserModule from "src/store/modules/User.module";
import FormView from "src/mixins/FormView";

export default {
	name: "UserForm",
	components: {},
	mixins: [new FormView(UserModule, "user")],
	props: [],
	data () {
		return {
			form: {
				name: null,
			},
		};
	},
	computed: {
		isNew () {
			return !this.user.id;
		},
	},
};
</script>
